// Host-only, first-party attribution shared by assessment and public signup.
// Never create _fbp: only Meta's real browser identifier is forwarded.
const QUERY_KEYS = ['fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
const MAX_AGE = 90 * 24 * 60 * 60;
const memory = {};
const validFbc = value => /^fb\.1\.\d{13}\..+$/.test(value || '');

function readCookies() {
    const result = {};
    try {
        document.cookie.split(';').forEach(pair => {
            const separator = pair.indexOf('=');
            if (separator < 0) return;
            try {
                result[pair.slice(0, separator).trim()] = decodeURIComponent(pair.slice(separator + 1));
            } catch (_) { /* Ignore a malformed cookie, not the entire snapshot. */ }
        });
    } catch (_) { /* Browser privacy settings must not block forms. */ }
    return result;
}

function persist(key, value) {
    memory[key] = value;
    try {
        const expires = new Date(Date.now() + MAX_AGE * 1000).toUTCString();
        // No Domain attribute intentionally limits attribution to this exact host.
        document.cookie = `${key}=${encodeURIComponent(value)}; Path=/; Max-Age=${MAX_AGE}; Expires=${expires}; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`;
        if (readCookies()[key] === value) delete memory[key];
    } catch (_) { /* Keep this page's snapshot if persistence is unavailable. */ }
}

function captureAttribution() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return {};
    const cookies = readCookies();
    const saved = { ...cookies, ...memory };
    const result = {};
    QUERY_KEYS.forEach(key => { if (saved[key]) result[key] = saved[key]; });
    if (validFbc(saved._fbc)) result._fbc = saved._fbc;
    if (cookies._fbp) result._fbp = cookies._fbp;
    const query = new URLSearchParams(window.location.search);
    QUERY_KEYS.forEach(key => {
        const value = query.get(key);
        if (!value) return;
        if (result[key] !== value) persist(key, value);
        result[key] = value;
    });
    const click = query.get('fbclid');
    if (click && (!result._fbc || result._fbc.split('.').slice(3).join('.') !== click)) {
        result._fbc = `fb.1.${Date.now()}.${click}`;
        persist('_fbc', result._fbc);
    }
    return result;
}

// Also importable by the repository's Node component fixtures without bundling.
module.exports = { captureAttribution };
